import React, { useState, useEffect } from 'react';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

import {notification,Input, Button } from 'antd';

import MaskedInput from 'antd-mask-input';

import { FormattedMessage, useIntl } from 'react-intl';

import _service from '@netuno/service-client';

const langContext = 'components.service-select';

export default ({email, data}) => {
  const [emailVisible, setEmailVisible] = useState(false)
  
  const intl = useIntl();

  function contactLog() {
    setEmailVisible(true)
    _service({
      method: 'PUT',
      url: "/contact",
      data: {contacted_id: data.client_id},
      success: (response) => {
          
      },
      fail: (e) => {
          notification["error"]({
              message: intl.formatMessage({id: `${langContext}.error.message`}),
              description: e.response.json.error,
          });
      }
  });
  }

  return (
    <>
      {
        emailVisible ? 
        (
          <div>
            <Input bordered={false} readOnly defaultValue={email}
            style={{'width':'fit-content'}}/>
          </div>
        ) :
        (
        <div>
          <Input.Password bordered={false} visibilityToggle={false} readOnly defaultValue={email}
        style={{'width':'fit-content'}}/>
        <Button type='secondary'  onClick={contactLog}>{intl.formatMessage({id: 'components.email-show.button'})}</Button>
        </div>)
      }
    </>
  );
};